import type * as Types from '../../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAnalyticsSettingsQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetAnalyticsSettingsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly kpiSettings: { readonly __typename?: 'YalperKpiSettings', readonly attributionModel?: Types.YalperAnalyticAttributionModelEnum | null, readonly goals: ReadonlyArray<number>, readonly revenueGoalId?: number | null }, readonly analyticGoals: ReadonlyArray<{ readonly __typename?: 'YalperAnalyticGoal', readonly id: number, readonly isEcomm: boolean, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null } | null };


export const GetAnalyticsSettingsDocument = gql`
    query GetAnalyticsSettings($companyId: ID) {
  currentUser {
    company(id: $companyId) {
      kpiSettings {
        attributionModel
        goals
        revenueGoalId
      }
      analyticGoals(companyId: $companyId) {
        id
        isEcomm
        name
        counterId
        counterName
      }
    }
  }
}
    `;

/**
 * __useGetAnalyticsSettingsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSettingsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAnalyticsSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>(GetAnalyticsSettingsDocument, options);
      }
export function useGetAnalyticsSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>(GetAnalyticsSettingsDocument, options);
        }
export function useGetAnalyticsSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>(GetAnalyticsSettingsDocument, options);
        }
export type GetAnalyticsSettingsQueryHookResult = ReturnType<typeof useGetAnalyticsSettingsQuery>;
export type GetAnalyticsSettingsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSettingsLazyQuery>;
export type GetAnalyticsSettingsSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticsSettingsSuspenseQuery>;
export type GetAnalyticsSettingsQueryResult = Apollo.QueryResult<GetAnalyticsSettingsQueryPage, GetAnalyticsSettingsQueryVariables>;